// extracted by mini-css-extract-plugin
export default {"formWrapper":"item-detail-form_formWrapper__6oGV6","actionBtnWrapper":"item-detail-form_actionBtnWrapper__lqT+O","nextBtn":"item-detail-form_nextBtn__3wHXZ"};